import {css} from 'lit'; export default css`:host([size=small]) .error-pictogram{--goto-icon-size:var(--goto-layout-04)}:host([size=small]) chameleon-empty-state{max-width:100%}`;
    